// Frontend constants — backend is now the source of truth.
export const STORAGE_KEYS = {
  TOKEN: "queue_token_v2",
  STATION: "queue_station_v2",
};

export const BROADCAST_CHANNEL = "queue_channel_v2";

export const BROADCAST_EVENTS = {
  TICKET_CALLED: "TICKET_CALLED",
  CONFIG_UPDATED: "CONFIG_UPDATED",
  STATE_UPDATED: "STATE_UPDATED",
  RECALL: "RECALL",
  RESET: "RESET",
};

export const LAYOUT_MODES = {
  MEDIA_RIGHT: "media_right",
  MEDIA_LEFT: "media_left",
  FULLSCREEN_PASSWORD: "fullscreen_password",
  FULLSCREEN_MEDIA: "fullscreen_media",
  PASSWORD_TOP: "password_top",
  MEDIA_TOP: "media_top",
  PASSWORD_70_RIGHT: "password_70_right",
  MEDIA_70_RIGHT: "media_70_right",
  PIP_MEDIA_BR: "pip_media_br", // password fullscreen + small media at bottom-right
  PIP_PASSWORD_BR: "pip_password_br", // media fullscreen + small password card bottom-right
  CARDS: "cards", // priority + 3 normal history cards + media + clock
  CUSTOM: "custom",
};

// Layouts shown in the admin picker (others kept in LAYOUT_MODES for legacy compat).
export const LAYOUT_PRESETS = [
  LAYOUT_MODES.MEDIA_RIGHT,
  LAYOUT_MODES.PASSWORD_TOP,
  LAYOUT_MODES.MEDIA_TOP,
  LAYOUT_MODES.FULLSCREEN_PASSWORD,
  LAYOUT_MODES.PIP_MEDIA_BR,
  LAYOUT_MODES.CARDS,
];

export const LAYOUT_LABELS = {
  media_right: "Senha à esquerda · Mídia à direita",
  media_left: "Mídia à esquerda · Senha à direita",
  fullscreen_password: "Tela cheia · Apenas Senha",
  fullscreen_media: "Tela cheia · Apenas Mídia",
  password_top: "Senha em cima · Mídia embaixo",
  media_top: "Mídia em cima · Senha embaixo",
  password_70_right: "Senha 70% · Mídia 30% (lado a lado)",
  media_70_right: "Mídia 70% · Senha 30% (lado a lado)",
  pip_media_br: "Senha gigante · Mídia em PiP (canto)",
  pip_password_br: "Mídia gigante · Senha em PiP (canto)",
  cards: "Cards (Prioritário + Normais + Relógio)",
  custom: "Layout Personalizado",
};

export const MEDIA_TYPES = {
  YOUTUBE: "youtube",
  MP4: "mp4",
  SLIDES: "slides",
  RSS: "rss",
  PLAYLIST: "playlist",
  NONE: "none",
};

// Single playlist item types (formato individual dentro de uma playlist mista)
export const PLAYLIST_ITEM_TYPES = {
  IMAGE: "image",
  YOUTUBE: "youtube",
  MP4: "mp4",
  RSS: "rss",
};

export const TTS_LANGUAGES = [
  { code: "pt-BR", label: "Português (Brasil)", template: "Senha {ticket}, {nomenclature} {desk}" },
  { code: "en-US", label: "English (US)", template: "Ticket {ticket}, {nomenclature} {desk}" },
  { code: "es-ES", label: "Español", template: "Turno {ticket}, {nomenclature} {desk}" },
  { code: "fr-FR", label: "Français", template: "Ticket {ticket}, {nomenclature} {desk}" },
  { code: "it-IT", label: "Italiano", template: "Biglietto {ticket}, {nomenclature} {desk}" },
  { code: "de-DE", label: "Deutsch", template: "Nummer {ticket}, {nomenclature} {desk}" },
];

// Mirrors backend default config (used as a fallback before first fetch)
export const DEFAULT_CONFIG = {
  brandName: "FILA INTELIGENTE",
  nomenclature: "Guichê",
  layout: LAYOUT_MODES.MEDIA_RIGHT,
  colors: {
    passwordBg: "#FFFFFF",
    passwordBgOpacity: 1,
    passwordBgImage: "",
    passwordText: "#0A0A0A",
    passwordAccent: "#FF3B30",
    historyAccent: "#0055FF",
    historyCardBg: "#FFFFFF",
    historyCardBgOpacity: 1,
    historyCardBgImage: "",
    mediaBg: "#F3F4F6",
    mediaBgOpacity: 1,
    mediaBgImage: "",
    tickerBg: "#0A0A0A",
    tickerBgOpacity: 1,
    tickerText: "#FFFFFF",
  },
  desks: ["01", "02", "03", "04", "05", "06"],
  prefixes: ["A", "B", "C", "D"],
  media: {
    type: MEDIA_TYPES.SLIDES,
    youtubeUrl: "",
    mp4Url: "",
    rssUrl: "https://feeds.bbci.co.uk/news/rss.xml",
    slides: [
      "https://images.unsplash.com/photo-1772001936267-b6058748eff4?w=1600&q=70",
      "https://images.unsplash.com/photo-1613479729852-e682ab024ba6?w=1600&q=70",
    ],
    slideInterval: 8,
    // Playlist mista: itens reproduzidos em sequência (image | youtube | mp4 | rss)
    playlist: [],
    playlistShuffle: false,
    volume: 1.0,
  },
  ticker: ["Bem-vindo", "Mantenha seu cartão visível"],
  showClock: true,
  tts: { enabled: true, lang: "pt-BR", rate: 0.95, pitch: 1.0, volume: 1.0, repeat: 2, gender: "auto", voiceURI: "" },
  kiosk: { wakeLock: true, silentByDefault: false, heartbeat: true, autoReloadTime: "" },
  layoutCustom: {
    orientation: "horizontal", // 'horizontal' | 'vertical' | 'pip'
    passwordRatio: 50,          // 20..80 % occupied by password area
    passwordPosition: "left",   // 'left' | 'right' | 'top' | 'bottom' (for h/v); 'tl'|'tr'|'bl'|'br' (for pip — corner of the small element)
    pipTarget: "media",         // for 'pip' orientation: which side is the small floating element ('media' or 'password')
    pipSize: 25,                // PiP size as % of viewport min(w,h)
  },
};

export const DEFAULT_STATE = {
  currentTicket: null,
  history: [],
  nextNumberByPrefix: { A: 101, B: 101, C: 101, D: 101 },
};
